import { zoneRegistry } from "mco-zone-configurations"

const useIsZone = () => {
	return {
		isDevelopment: zoneRegistry.isDevelopment(),
		isTest: zoneRegistry.isTest(),
		isStaging: zoneRegistry.isStaging(),
		isProduction: zoneRegistry.isProduction()
	}
}

export default useIsZone
